import { BaseObject, IBaseObject } from './BaseObject';

export interface IAvancement extends IBaseObject {
  nomEquipement: string;
  nomSousSysteme: string;
  numeroPgm: string;
  descriptionCodeReponse: string;
  message: string;
  dateFinEstimee: string;
}

export class Avancement extends BaseObject implements IAvancement {
  dateFinEstimee!: string;
  descriptionCodeReponse!: string;
  message!: string;
  nomEquipement!: string;
  nomSousSysteme!: string;
  numeroPgm!: string;
  dateFinEstimeeAsDate!: Date;
  progress: number = -1;

  private interval: any;

  constructor(props?: IAvancement) {
    super(props);

    if (props) {
      Object.assign(this, props);
      if (this.dateFinEstimee) {
        this.dateFinEstimeeAsDate = new Date(this.dateFinEstimee);
        this.progress = this.calculateProgress();
        this.simulateInterval();
      }
    }
  }

  private calculateProgress(): number {
    if (
      this.descriptionCodeReponse === 'Terminé' ||
      this.descriptionCodeReponse === 'Non concerné'
    ) {
      return 100;
    }

    if (!this.dateFinEstimeeAsDate) {
      return -1;
    }

    const end = this.dateFinEstimeeAsDate.getTime();
    const now = new Date().getTime();
    if (now > end) {
      return 100;
    }

    const diff = (end - now) / 1000;
    const percent = Math.abs(3600 - diff);
    return Math.trunc((percent / 3600) * 100);
  }

  private simulateInterval() {
    this.interval = setInterval(() => {
      this.progress = this.calculateProgress();
      if (this.progress === 100) {
        clearInterval(this.interval);
      }
    }, 5000);
  }
}
